

import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import About from "../components/About";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";



function Home(){
  return (
    <div className="font-sans bg-white text-gray-900">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <ContactForm />
      <Footer />
    </div>
  );
}
// fixed 
export default Home;
